import React, { useState, useEffect, useContext } from "react";
import profileImg from "../assets/profile_man2.webp";
import profileImgIos from "../assets/profile_man2.png";
import deleteImg from "../assets/delete.webp";
import deleteImgIos from "../assets/delete.png";
import "../CSS/profile.css";
import { deleteUser, updateUserName, logout, attachRecaptcha } from "../../api/accounts";
import { getUserDetails } from "../../api/users";
import { updateUserData } from "../../api/users";
import { Formik, Field, getIn, ErrorMessage } from "formik";
import * as Yup from "yup";
import AuthContext from "../../context/AuthContext";
import allowedCities from "../static/allowedCities";
import history from "../history/history";
import Swal from "sweetalert2";
import { decrementRequesterCount } from "../../api/stats";
import otpHelper from "./otpHelper";

export default function DonorProfile({ user }: any) {
  const [showDeleteSection, setShowDeleteSection] = useState(false);
  // Setting default values for profile
  const [details, setDetails] = useState({
    name: "",
    city: "",
    contact: "",
    userType: "",
  } as any);

  useEffect(() => {
    attachRecaptcha("recaptcha-container");
    if (user) {
      getUserDetails(user.uid, user.userType)
        .then((details: any) => {
          details.contact = `0${details.contact.substr(2)}`;
          setDetails({ ...details });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  return showDeleteSection ? (
    <DeleteSection setShowDeleteSection={setShowDeleteSection} />
  ) : (
    <div className="profile-main">
      <div className="profile-img-container">
      <picture>
        <source srcSet={profileImg} type="image/webp" />
        <source srcSet={profileImgIos} type="image/png" />
        <img src={profileImgIos} alt="Background" className="profile-back-img" />
      </picture>
      </div>
      <div className="profile-inner">
        <h3>Edit information</h3>
        <p>{details.email}</p>
        <Formik
          enableReinitialize
          initialValues={{
            name: details.name,
            city: details.city,
            contact: details.contact,
          }}
          validationSchema={Yup.object({
            name: Yup.string()
              .max(20, "Name must be less than 20 characters long")
              .required("Your name is required"),
            city: Yup.string()
              .oneOf(allowedCities, "Invalid city")
              .required("Select one of the options"),
            contact: Yup.string()
              .required("Contact number is required")
              .matches(/^[0-9]+$/, "Phone number must only contain digits")
              .min(11, "Phone number must be of exactly 11 digits")
              .max(11, "Phone number must be of exactly 11 digits"),
          })}
          onSubmit={(values, { setSubmitting }) => {
            // alert(JSON.stringify(values, null, 2));
            const contact = `92${values.contact.substr(1)}`;
            const sameNumber = () => {
              if (details.contact === values.contact) {
                return true;
              } else return false;
            }
            // values.contact = `92${values.contact.substr(1)}`;
            otpHelper(contact, values, setSubmitting, false, false, sameNumber(), () => 
              updateUserData({...values, contact}, user.uid, user.userType)
                .then(async () => {
                  // also updating user name
                  await updateUserName(values.name);
                  setSubmitting(false);
                  Swal.fire({
                    icon: "success",
                    title: "Profile Updated!",
                    showConfirmButton: false,
                  });
                  setTimeout(() => {
                    window.location.reload(false); // reload page to reflect change
                  }, 1500);
                })
                .catch((err) => {
                  alert(err);
                }) 
            )
          }}
        >
          {({ isSubmitting, handleSubmit, errors, touched }) => (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                {["name", "contact"].map((attr, i) => {
                  return (
                    <div>
                      <label>{["Name:", "Contact Number:"][i]}</label>
                      <Field
                        type="name"
                        name={attr}
                        className={
                          getIn(errors, attr) && getIn(touched, attr)
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                      {getIn(errors, attr) && getIn(touched, attr) && (
                        <div className="invalid-feedback">
                          <small>{getIn(errors, attr)}</small>
                        </div>
                      )}
                    </div>
                  );
                })}
                <div className="form-group">
                  <label htmlFor="city">City</label>
                  <Field
                    className={`form-control ${
                      touched.city && errors.city ? "is-invalid" : ""
                    }`}
                    name="city"
                    as="select"
                  >
                    <option value="">Select your city</option>
                    {allowedCities.map((city) => {
                      return <option key={city}>{city}</option>;
                    })}
                  </Field>
                  <ErrorMessage
                    component="div"
                    name="city"
                    className="invalid-feedback"
                  />
                </div>
                <button
                  className="btn btn-block btn-primary"
                  id="update-button"
                  disabled={isSubmitting}
                  type="submit"
                >
                  Update
                </button>
                <div id="recaptcha-container"></div>
              </div>
            </form>
          )}
        </Formik>
        <hr />
        <h3>Delete Account</h3>
        <button
          className="btn btn-block btn-danger"
          id="delete-button"
          onClick={() => {
            setShowDeleteSection(true);
          }}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

const DeleteSection = ({ setShowDeleteSection }: any) => {
  const { user }: any = useContext(AuthContext);
  const [type, setType] = useState("password");
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-primary mr-2",
      cancelButton: "btn btn-danger ml-2",
    },
    buttonsStyling: false,
  });

  return (
    <div className="delete-main">
      <div className="profile-delete-img-container">
      <picture>
        <source srcSet={deleteImg} type="image/webp" />
        <source srcSet={deleteImgIos} type="image/png" />
        <img src={deleteImgIos} alt="Background" className="profile-delete-img" />
      </picture>
      </div>
      <div className="profile-inner">
        <h3>Are you sure you want to delete your account?</h3>
        <Formik
          enableReinitialize
          initialValues={{ password: "" }}
          onSubmit={(values, { setSubmitting }) => {
            swalWithBootstrapButtons
              .fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
              })
              .then((result) => {
                if (result.value) {
                  deleteUser(values.password, user.userType)
                    .then(() => {
                      decrementRequesterCount();
                      Swal.fire({
                        title: "Deleted!",
                        text: "Your account has been deleted.",
                        icon: "success",
                        showConfirmButton: false,
                      });
                      logout();
                      setTimeout(() => window.location.reload(true), 1500); // reload page to reflect change

                      setSubmitting(false);
                      history.push("/");
                    })
                    .catch((err: any) => alert("Could not delete account."));
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  swalWithBootstrapButtons.fire(
                    "Cancelled",
                    "Your account is safe!",
                    "error"
                  );
                  setSubmitting(false);
                }
              });
          }}
        >
          {({ isSubmitting, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Enter Password:</label>
                <Field className="form-control" type={type} name="password" />
                {type === "password" && (
                  <span
                    onClick={() => setType("text")}
                    title="Show password"
                    className="fa fa-eye fa-2x hide-password-span"
                  ></span>
                )}
                {type === "text" && (
                  <span
                    onClick={() => setType("password")}
                    title="Hide password"
                    className="fa fa-eye-slash fa-2x hide-password-span"
                  ></span>
                )}

                <p></p>
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="btn btn-block btn-danger"
                >
                  {isSubmitting ? (
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "Delete"
                  )}
                </button>
              </div>
            </form>
          )}
        </Formik>
        <button
          className="btn btn-block btn-primary"
          onClick={() => {
            setShowDeleteSection(false);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};
